import React from 'react'
import SubHeader from '../components/SubHeader'
import ServiceList from '../components/ServiceList'
import WhyChooseUs from '../components/WhyChooseUs'
import OurSkills from '../components/OurSkills'
const Services = () => {
  return (
    <>
      <SubHeader />
      <ServiceList />
      <WhyChooseUs />
      <OurSkills />
      
    </>
  )
}

export default Services
